'use strict';
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path');

module.exports = {
  //ROOT_API: process.env.NODE_ENV === 'production' ? 'http://arcoapi' : 'http://localhost:3001',
  //ROOT_API: process.env.NODE_ENV === 'production' ? 'http://adbdocker.swen-net.it:3001' : 'http://localhost:3001',
  //ROOT_API: process.env.NODE_ENV === 'production' ? 'http://adbdocker.swen-net.it:3001' : 'http://10.0.2.2:3001',
  // ROOT_API: process.env.NODE_ENV === 'production' ? 'https://arco-api.swen.it' : process.env.NODE_ENV === 'staging' ? 'http://adbdocker.swen-net.it:3001' : 'http://localhost:3001',

  ENV: process.env.VUE_APP_MODE,
  ROOT_API: process.env.VUE_APP_ROOT_API,
  //ROOT_API: process.env.NODE_ENV === 'production' ? 'http://adbdocker.swen-net.it:3001' : 'http://localhost:3001',
};
